import { h } from 'preact';
import * as BaseComp from 'components/bolt/burgerMenu/burgerMenu.js';
// import { accessNested } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/burgerMenu/burgerMenu.sss';

export default class BurgerMenu extends BaseComp.default {
	render(props) {
		const { navOpen } = props;
		// const copy = accessNested(Store.get(), 'appData.pages.map.data.copy');

		const burgerMenuIcon = (
			<div class={s.burgerWrapper}>
				<div class={s.circleFill}></div>
				<svg class={s.burgerIcon} stroke="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
					<path d="M2 8H14M2 4H14M2 12H10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel" />
				</svg>
				{/* <span class={s.label}>{copy?.map?.topNav?.menu}</span> */}
			</div>
		);
		const close = (
			<div class={s.burgerWrapper}>
				<div class={s.circleFill}></div>
				<svg class={s.closeIcon} stroke="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 4L4 12M4 4L12 12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="bevel" />
				</svg>
				{/* <span class={s.label}>{copy?.map?.topNav?.close}</span> */}
			</div>
		);
		const activePage = Store.get()?.activePage;
		const menu = navOpen || activePage === 'boltVideos' ? close : burgerMenuIcon;
		return menu;
	}
}
